import { ApiPrice } from '@ibe/api';

class AdditionalNightEvent {
  deltaPrice: ApiPrice;

  bookingNumber: string;
}

export default AdditionalNightEvent;
